import React from 'react';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import enhancement from '../../../../images/enhancement.png';
import LearnMoreCommon from '../LearnMoreCommon';

const SoftwareMaintenanceAndEnhancementPage = props => {
    const { t } = props;
    return (
        <LearnMoreCommon
            cardMediaImage={enhancement}
            cardMediaTitle={t(
                'landingPage.serviceSection.services.softwareMaintenanceAndEnhancement.header'
            )}
            headerTitle={t(
                'landingPage.serviceSection.services.softwareMaintenanceAndEnhancement.header'
            )}
            firstBlockText={t(
                'landingPage.serviceSection.services.softwareMaintenanceAndEnhancement.learnMore.firstBlock'
            )}
            contactUsDescription={t(
                'landingPage.serviceSection.services.softwareMaintenanceAndEnhancement.learnMore.contactUs'
            )}
            googleEventCategory="Services - SoftwareMaintenanceAndEnhancementPage"
        />
    );
};

export default compose(withTranslation())(
    SoftwareMaintenanceAndEnhancementPage
);
